import {
  mdiShieldBugOutline,
  mdiAccount,
  mdiMonitorEye,
  mdiShieldHalfFull,
  mdiDomain,
  mdiClipboardTextOutline,
} from '@mdi/js';
import { Whoami } from 'mir-utils/api/whoami';
import { i18n } from 'mir-utils/i18n';
import { Version } from '__generated__/version';
import { iconPathCentralConsole } from './iconPaths';

export type IsPageHiddenFunction = (params: { version: Version; whoami: Whoami }) => boolean;

export type Page = {
  name: string;
  title: () => string; // Функция, потому что переводить надо во время рендера
  url: string;
  docLink?: (v: Version) => string | null;
  iconPath: string;
  contentPadding?: number;
  innerPages?: Page[];
  isPageHidden?: IsPageHiddenFunction;
};

export const pages: Page[] = [
  {
    name: 'ngfw',
    title: () => i18n.t('NGFW'),
    docLink: (version) => version.docLinks.utm,
    url: '/ngfw',
    iconPath: mdiShieldHalfFull,
  },
  {
    name: 'download_central_console',
    title: () => i18n.t('Central console'),
    docLink: (version) => version.docLinks.cc,
    url: '/download_central_console',
    iconPath: iconPathCentralConsole,
  },
  {
    name: 'signatures',
    title: () => i18n.t('Signature database'),
    url: '/signatures',
    iconPath: mdiClipboardTextOutline,
  },
  {
    name: 'ideco_monitoring_bot',
    title: () => i18n.t('Monitoring Bot'),
    url: '/ideco-monitoring-bot',
    iconPath: mdiMonitorEye,
    isPageHidden: ({ version }) => !version.modules.monitoringBot,
  },
  {
    name: 'ideco_security',
    title: () => i18n.t('Security'),
    url: '/ideco-security',
    iconPath: mdiShieldBugOutline,
    isPageHidden: ({ version }) => !version.modules.idecoSecurity,
  },
  {
    name: 'personal_data',
    title: () => i18n.t('Personal data'),
    url: '/personal-data',
    iconPath: mdiAccount,
  },
  {
    name: 'companies',
    title: () => i18n.t('Companies'),
    url: '/companies',
    iconPath: mdiDomain,
  },
  // Пример вкладки с внутренними страницами
  // {
  //   name: "test_folder",
  //   title: () => "Test folder",
  //   url: "/test-folder",
  //   iconPath: mdiAccount,
  //   innerPages: [
  //     {
  //       name: "test_page",
  //       title: () => "Test page",
  //       url: "/test-page",
  //       iconPath: mdiAccount,
  //     },
  //   ]
  // }
  // Таким образом, структура файлов должна быть такая: pages/test_folder/test_page/index.tsx.
  // У страницы test_page в браузере будет следующий url: /test-folder/test-page.
];
